import { CardDef } from '@mythos/game/GameModel';
import {
  isCardMercenary,
  isCardScavenge,
  isCardSettlement,
} from '../game/Utility';

export function getGenericBasicScavenge(cardDefs: CardDef[]): CardDef {
  const scavengeAge1 = cardDefs.find((c) => isCardScavenge(c) && c.age === 1);
  if (!scavengeAge1) {
    throw new Error('Scavenge card not found in cardDefs');
  }
  return {
    ...scavengeAge1,
    name: 'Scavenge',
  };
}

export function getGenericBasicMercenary(cardDefs: CardDef[]): CardDef {
  const mercenaryAge1 = cardDefs.find((c) => isCardMercenary(c) && c.age === 1);
  if (!mercenaryAge1) {
    throw new Error('Mercenary card not found in cardDefs');
  }
  return {
    ...mercenaryAge1,
    name: 'Mercenary',
  };
}

export function getGenericBasicSettlement(cardDefs: CardDef[]): CardDef {
  const settlementAge1 = cardDefs.find(
    (c) => isCardSettlement(c) && c.age === 1,
  );
  if (!settlementAge1) {
    throw new Error('Settlement card not found in cardDefs');
  }
  return {
    ...settlementAge1,
    name: 'Settlement',
  };
}

export function getGenericBasicCards(cardDefs: CardDef[]): {
  scavenge: CardDef;
  mercenary: CardDef;
  settlement: CardDef;
} {
  return {
    scavenge: getGenericBasicScavenge(cardDefs),
    mercenary: getGenericBasicMercenary(cardDefs),
    settlement: getGenericBasicSettlement(cardDefs),
  };
}
